var render = function render(){var _vm=this,_c=_vm._self._c;return _c('picture',[_c('source',{attrs:{"srcSet":_vm.srcWebp,"type":"image/webp"}}),_c('img',{class:{ absolute: _vm.absolute },attrs:{"src":"data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==","data-src":_vm.fullSrcUrl}})])
}
var staticRenderFns = []

export { render, staticRenderFns }